import { MetricsList, TotalCounts } from "@/types/metrics";
import { styled } from "@stitches/react";
import { Table, Modal } from "@/vendor/Forge/dist";
import { useState, useEffect, useReducer } from "react";
import ColumnHeader from "../ColumnHeader";
import { ReactNode } from "react";
import { useMetricsContext } from "@/contexts/metrics-context";
import { SortOrder, Filter } from "@/types/order-table";
import AdvanceFilterWLimitContainer from "../AdvanceFilterWLimit";
interface ModalType {
  show: boolean;
  useLarge: boolean;
  headerText: string;
  renderForm: () => React.ReactNode;
}

const Wrapper = styled("div", {
  padding: "0 16px",
  display: "flex",
  flexFlow: "column",

  "& table": {
    marginLeft: "75px",
    width: "50em",
    height: "3em",
  },
  "& table th, & table td": {
    border: "1px solid #B6B7B7",
  },
  "& table th:first-child, & table td:first-child": {
    borderLeft: "1px solid #B6B7B7",
    padding: "0px",
    width: "25px",
  },
  "& .fe_c_table.fe_c_table--compact tbody td.fe_c_table__cell": {
    padding: "8px 12px",
  },
  "& .fe_c_table.fe_c_table--compact thead th.fe_c_table__header": {
    padding: "12px 12px",
  },
  "& tfoot > tr > td": {
    padding: "8px 12px",
    fontSize: 14,
  },
  "& tfoot > tr > td:first-child": {
    fontWeight: "bold",
    paddingLeft: "12px",
  },
});

const DownloadDisclaimer = styled("div", {
  marginLeft: "75px",
  display: "flex",
  justifyContent: "right",
});

const TableFooter = ({ data }: { data: TotalCounts }) => (
  <tfoot>
    <tr>
      <td data-testid="total">Total</td>
      <td data-testid="notStarted">{data.notStartedCount}</td>
      <td data-testid="pendingCount">{data.pendingCount}</td>
      <td data-testid="obtainedCount">{data.obtainedCount}</td>
      <td data-testid="closedCount">{data.closedCount}</td>
    </tr>
  </tfoot>
);

interface Props {
  totalCounts: TotalCounts;
  rows: MetricsList[];
}

const getSortOrder = (
  sortCriteria?: string,
  currentSortCriteria?: string,
  sortOrder?: SortOrder,
) => (currentSortCriteria !== sortCriteria ? null : sortOrder);

const getNewSortOrder = (
  sortCriteria?: string,
  currentSortCriteria?: string,
  sortOrder?: SortOrder,
) => {
  if (currentSortCriteria !== sortCriteria) return "ASC";
  return sortOrder === "DESC" || !sortOrder ? "ASC" : "DESC";
};

const MetricsTable = ({ totalCounts, rows }: Props) => {
  const [rowState, setRowState] = useState(rows);
  const { updateFilters, filters } = useMetricsContext();

  const [modal, setModal] = useReducer(
    (state: ModalType, changes: Partial<ModalType>) => ({
      ...state,
      ...changes,
    }),
    {
      show: false,
      useLarge: false,
      headerText: "",
      renderForm: () => null,
    },
  );

  //Note: product still in developemental stages with how this is supposed to look, if they want checkboxes, uncomment code
  //and input a new cell in the table footer

  // const handleCheckAll = () => {
  //   const assignedUsers = rows.map((row) => {
  //     return row.assignedUser;
  //   });

  //   setCheckedUsers(assignedUsers);

  //   setCheckAll(!checkAll);

  //   if (checkedUsers.length === assignedUsers.length) {
  //     setCheckedUsers([]);
  //   }
  //  };

  // const handleUserToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const isChecked = e.target.checked;
  //   const assignedUser = e.target.value;

  //   if (!isChecked) {
  //     setCheckedUsers((prevChecked) => {
  //       return prevChecked.filter((user) => user !== assignedUser);
  //     });
  //   } else {
  //     setCheckedUsers((prevChecked) => [...prevChecked, assignedUser]);
  //   }
  //  };

  // useEffect(() => {
  //   const assignedUsers = rows.map((row) => {
  //     return row.assignedUser;
  //   });

  //   setRowState(rowState.map((row) => {
  //     if (checkedUsers.includes(row.assignedUser)) {
  //       return { ...row, checked: true };
  //     } else {
  //       return { ...row, checked: false };
  //     }
  //   }));

  //   if (assignedUsers.length != checkedUsers.length) {
  //     setCheckAll(false);
  //   } else if (assignedUsers.length == checkedUsers.length) {
  //     setCheckAll(true);
  //   }

  //   if (assignedUsers.length === 0) {
  //     setCheckAll(false);
  //   }
  // // eslint-disable-next-line
  //  }, [checkedUsers]);

  useEffect(() => {
    setRowState(rows);
  }, [rows]);

  const handleFilterClick = ({
    type,
    header,
  }: {
    type: Filter;
    header: string;
  }) => {
    setModal({
      show: true,
      useLarge: true,
      headerText: `Filter by ${header}`,
      renderForm: () => (
        <AdvanceFilterWLimitContainer
          type={type}
          useContext={useMetricsContext}
        />
      ),
    });
  };

  const columns = [
    // {
    //   key: "assignedUser",
    //   displayName: "Checkbox",
    //   header: {
    //     formatters: [
    //       () => (
    //         <Checkbox
    //           id="checkboxHeader"
    //           data-testid="checkboxHeader"
    //           description=""
    //           checked={checkAll}
    //           onChange={handleCheckAll}
    //         />
    //       ),
    //     ],
    //   },
    //   template: (assignedUser: MetricsList["assignedUser"], rowData: RowData<MetricsList>) => {
    //     return (
    //       <Checkbox
    //         key={assignedUser}
    //         description=""
    //         id={assignedUser}
    //         data-testid="checkbox"
    //         value={assignedUser}
    //         checked={rowData?.rowData.checked}
    //         onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    //           return handleUserToggle(e);
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      key: "assignedUser",
      displayName: "User",
      header: {
        formatters: [
          (name: ReactNode) => (
            <ColumnHeader
              id="user"
              name={name}
              onFilterClick={() =>
                handleFilterClick({ type: "assignedUser", header: "User" })
              }
              sortOrder={getSortOrder(
                "assignedUser",
                filters?.sortCriteria,
                filters?.sortOrder,
              )}
              onSortClick={() => {
                updateFilters({
                  sortCriteria: "assignedUser",
                  sortOrder: getNewSortOrder(
                    "assignedUser",
                    filters?.sortCriteria,
                    filters?.sortOrder,
                  ),
                });
              }}
              isActiveFilter={!!filters?.assignedUsers?.length}
              activeFilterCount={filters?.assignedUsers?.length}
            />
          ),
        ],
      },
    },
    {
      //todo: confirm with doc martin what needs to be done with these filters
      key: "notStartedCount",
      displayName: "Not Started",
      header: {
        formatters: [
          (name: ReactNode) => (
            <ColumnHeader
              id="notStartedCount"
              name={name}
              sortOrder={getSortOrder(
                "notStartedCount",
                filters?.sortCriteria,
                filters?.sortOrder,
              )}
              onSortClick={() => {
                updateFilters({
                  sortCriteria: "notStartedCount",
                  sortOrder: getNewSortOrder(
                    "notStartedCount",
                    filters?.sortCriteria,
                    filters?.sortOrder,
                  ),
                });
              }}
            />
          ),
        ],
      },
    },
    {
      key: "pendingCount",
      displayName: "Pending",
      header: {
        formatters: [
          (name: ReactNode) => (
            <ColumnHeader
              id="pendingCount"
              name={name}
              sortOrder={getSortOrder(
                "pendingCount",
                filters?.sortCriteria,
                filters?.sortOrder,
              )}
              onSortClick={() => {
                updateFilters({
                  sortCriteria: "pendingCount",
                  sortOrder: getNewSortOrder(
                    "pendingCount",
                    filters?.sortCriteria,
                    filters?.sortOrder,
                  ),
                });
              }}
            />
          ),
        ],
      },
    },
    {
      key: "obtainedCount",
      displayName: "Obtained",
      header: {
        formatters: [
          (name: ReactNode) => (
            <ColumnHeader
              id="obtainedCount"
              name={name}
              sortOrder={getSortOrder(
                "obtainedCount",
                filters?.sortCriteria,
                filters?.sortOrder,
              )}
              onSortClick={() => {
                updateFilters({
                  sortCriteria: "obtainedCount",
                  sortOrder: getNewSortOrder(
                    "obtainedCount",
                    filters?.sortCriteria,
                    filters?.sortOrder,
                  ),
                });
              }}
            />
          ),
        ],
      },
    },
    {
      key: "closedCount",
      displayName: "Closed",
      header: {
        formatters: [
          (name: ReactNode) => (
            <ColumnHeader
              id="closedCount"
              name={name}
              sortOrder={getSortOrder(
                "closedCount",
                filters?.sortCriteria,
                filters?.sortOrder,
              )}
              onSortClick={() => {
                updateFilters({
                  sortCriteria: "closedCount",
                  sortOrder: getNewSortOrder(
                    "closedCount",
                    filters?.sortCriteria,
                    filters?.sortOrder,
                  ),
                });
              }}
            />
          ),
        ],
      },
    },
  ];

  return (
    <Wrapper>
      <DownloadDisclaimer>
        {totalCounts.totalCount > 1000 ? (
          <p>Download orders limited to 1000 records.</p>
        ) : (
          <></>
        )}
      </DownloadDisclaimer>
      <Table
        rowKey="assignedUser"
        layout="compact"
        columns={columns}
        rows={rowState}
      >
        <TableFooter data={totalCounts} />
      </Table>
      <Modal
        show={modal.show}
        headerText={modal.headerText}
        includeButtonRow={false}
        onHide={() => setModal({ show: false })}
        width={modal.useLarge ? "large" : "small"}
      >
        {modal.renderForm()}
      </Modal>
    </Wrapper>
  );
};

export default MetricsTable;
